import React from "react";
import PropTypes from "prop-types";
import { Box, Container } from "@mui/material";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import EnvInfo from "layout-blueprints/EnvInfo";

const MinimalLayout = (props) => {
  const { children } = props;

  return (
    <Box
      className="MinimalLayout"
      display="flex"
      flexDirection="column"
      minHeight="100vh"
    >
      <EnvInfo />
      <Header />

      {/* Contenuto principale che cresce per riempire lo spazio */}
      <Box flex={1} padding={0} marginBottom="0px" textAlign="center">
        <Container maxWidth="md">{children}</Container>
      </Box>

      <Footer />
    </Box>
  );
};

MinimalLayout.propTypes = {
  children: PropTypes.node,
};

export default MinimalLayout;
